import { IHeader } from './DocumentsBody.types';

export const headings: IHeader[] = [
  {
    fieldName: 'label',
  },
  {
    fieldName: 'associatedWithName',
  },
  {
    fieldName: 'associatedWithSource',
  },
  {
    fieldName: 'addedByName',
  },
  {
    fieldName: 'createdAt',
  },
];
